import React from 'react';
import { Row, Col } from 'antd';

import { HeaderStep } from './Header';
import { ContentStep } from './Content';
import type { Steps } from '@/context/KimLhc/types';

interface StepComponentProps {
	steps: Steps[];
}

export function StepComponent({ steps }: Readonly<StepComponentProps>): JSX.Element {
	return (
		<Row gutter={[16, 24]} justify="center">
			<Col span={24}>
				<HeaderStep steps={steps} />
			</Col>
			<Col span={24}>
				<ContentStep steps={steps} />
			</Col>
		</Row>
	);
}
